import {v4 as uuidv4} from 'uuid';

export function generateNumberUuid(): number {
  const uuid = uuidv4();
  const buffer = Buffer.from(uuid);
  return buffer.readUInt32BE(0);
}
